<template>
  <div class="col-md-5 dragme" v-if="currentUser.access > 2">
    <div class="portlet light" :class="{'movable' : movable}">
      <i v-if="movable" class="fa fa-arrows-alt arrow-move" aria-hidden="true"></i>
      <div class="module-name">Referral Feed</div>
      <div class="portlet-title tabbable-line">
        <div class="caption caption-md">
          <span class="caption-subject font-dark sbold uppercase">Referral/Application Feed</span>
        </div>
        <ul class="nav nav-tabs">
          <li :class="{active: activeTab == 'pending'}" @click="setActiveTab('pending')">
            <a href="#pending" data-toggle="tab" aria-expanded="false">Pending</a>
          </li>
          <li :class="{active: activeTab == 'enrolled'}" @click="setActiveTab('enrolled')">
            <a href="#enrolled" data-toggle="tab" aria-expanded="false">Enrolled</a>
          </li>
          <li :class="{active: activeTab == 'not-enrolled'}" @click="setActiveTab('not-enrolled')">
            <a href="#not-enrolled" data-toggle="tab" aria-expanded="false">Not Enrolled</a>
          </li>
        </ul>
      </div>

      <div class="portlet-body">
        <div v-if="loading.indexGrouped">
          <div class="clearfix"></div>
          <vue-spinner></vue-spinner>
        </div>

        <template v-else>

          <div class="tab-content marginTop margin-bottom-15">
            <div class="tab-pane" v-if="activeTab=='pending'" id="pending" v-bar>
              <ul class="feeds" v-if="referrals.hasOwnProperty('pending')">
                <li v-for="record in referrals.pending">
                  <router-link :to="{ name: 'Referral Dashboard', params: { id: record.id } }" tag="a">
                    <div class="col1">
                      <div class="cont">
                        <div class="cont-col2">
                          <div class="desc">Referral/Application received for {{ record.name }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="col2">
                      <div class="date">{{ record.created_at.date | formatDateModal }}</div>
                    </div>
                  </router-link>
                </li>
              </ul>
              <div v-else></div>
            </div>

            <div class="tab-pane"  v-if="activeTab=='enrolled'" id="enrolled" v-bar>
              <ul class="feeds" v-if="referrals.hasOwnProperty('enrolled')">
                <li v-for="record in referrals.enrolled">
                  <router-link :to="{ name: 'Dashboard Participant', params: { id: record.enrolled_participant_id } }" tag="a">
                    <div class="col1">
                      <div class="cont">
                        <div class="cont-col2">
                          <div class="desc">Referral completed for {{ record.name }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="col2">
                      <div class="date">{{ record.created_at.date | formatDateModal }}</div>
                    </div>
                  </router-link>
                </li>
              </ul>
              <div v-else></div>
            </div>

            <div class="tab-pane" v-if="activeTab=='not-enrolled'" id="not-enrolled" v-bar>
              <ul class="feeds" v-if="referrals.hasOwnProperty('not_enrolled')">
                <li v-for="record in referrals.not_enrolled">
                  <router-link :to="{ name: 'Referral Dashboard', params: { id: record.id } }" tag="a">
                    <div class="col1">
                      <div class="cont">
                        <div class="cont-col2">
                          <div class="desc">Referral completed for {{ record.name }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="col2">
                      <div class="date">{{ record.created_at.date | formatDateModal }}</div>
                    </div>
                  </router-link>
                </li>
              </ul>
              <div v-else></div>
            </div>
          </div>
        </template>
      </div>

      <div class="btn-arrow-link pull-right">
        <a @click.prevent="showAllReferrals" class="text-warning">VIEW ALL <i class="icon-arrow-right black"></i></a>
      </div>


      <referral-show-all-modal v-if="showAllReferralsModal" v-on:hide="showAllReferralsModal=false"></referral-show-all-modal>

      <div class="clearfix"></div>
    </div>
  </div>
</template>
<script>
  import {mapGetters, mapActions} from 'vuex';
  import Spinner from '@/components/Spinner';
  import ReferralShowAllModal from "../../pages/ReferralDashboard/ReferralShowAllModal";

  export default {
    components: {
      ReferralShowAllModal,
      'vue-spinner': Spinner
    },

    props: {'movable': {type: Boolean, default: true}},

    data() {
      return {
        activeTab: 'pending',
        showAllReferralsModal: false
      }
    },
    mounted() {
      this.fetchReferrals();
    },
    computed: {
      ...mapGetters({
        user: 'getParticipant',
        loading: 'referrals/getLoading',
        referrals: 'referrals/getIndexGrouped',
        currentUser: 'getUser'
      })
    },
    methods: {
      ...mapActions({
        fetchReferrals: 'referrals/fetchIndexGrouped',
      }),
      setActiveTab(tab) {
        this.activeTab = tab;
      },
      showAllReferrals() {
        this.showAllReferralsModal = true;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tab-pane {
    display: block;
  }
  .portlet.movable {
    height: 385px;
    .portlet-body {
      overflow: hidden;
    }
    .tab-pane {
      height: 255px;
    }

    @media('max-width: 1400px') {
      .tab-pane {
        height: 210px;
      }
    }

    @media('max-width: 1005px') {
      .tab-pane {
        height: 180px;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// ReferralFeed.vue?696cec86